import { render, staticRenderFns } from "./EditMedicalCertificate.vue?vue&type=template&id=581d0236"
import script from "./EditMedicalCertificate.vue?vue&type=script&lang=ts"
export * from "./EditMedicalCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports